import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { infoDetailsProps } from "types/models/infoDetailsProps";

type State = {
  pgp2: boolean;
  pgp3: boolean;
  add1: boolean;
  add2: boolean;
  remove2: boolean;
  remove3: boolean;
};

const initialState: State = {
  pgp2: false,
  pgp3: false,
  add1: true,
  add2: false,
  remove2: false,
  remove3: false,
};

export const pendingSlice = createSlice({
  name: "pgp",
  initialState: initialState,
  reducers: {
    setPgp2: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        pgp2: actions.payload,
      };
    },
    setPgp3: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        pgp3: actions.payload,
      };
    },
    setAdd1: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        add1: actions.payload,
      };
    },
    setAdd2: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        add2: actions.payload,
      };
    },
    setRemove2: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        remove2: actions.payload,
      };
    },
    setRemove3: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        remove3: actions.payload,
      };
    },
  },
});

export const { setAdd1, setAdd2, setPgp2, setPgp3, setRemove2, setRemove3 } =
  pendingSlice.actions;
export default pendingSlice.reducer;
